export default "/images/vendor/flag-icon-css/flags/4x3/sg.svg?8b629e7bf137abf1643b88d0e02d9d3a";